#import "../../fragments/UserFragment.graphql"

query GetUsersQuery {
  users(filter: { isCommunityContributor: true }) {
    edges {
      node {
        id
        ... on User {
          ...UserFragment
        }
      }
    }
  }
}
